export default __webpack_public_path__ + "static/media/Lock.1aadeb60.svg";